import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsTractorsTrailerWidthChoiceReportComponent } from './fields-interventions-tractors-trailer-width-choice-report.component';
import {DxChartModule, DxPivotGridModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsTractorsTrailerWidthChoiceReportComponent],
  imports: [
    CommonModule,
    DxPivotGridModule,
    DxChartModule
  ],
  exports: [FieldsInterventionsTractorsTrailerWidthChoiceReportComponent]
})
export class FieldsInterventionsTractorsTrailerWidthChoiceReportModule { }
